module.exports = "<template> <div class=tyl-divider role=separator tabindex=-1></div> </template>";